const types = {
	//Get Template name
	GET_PT_PROGRAM_START: "GET_PT_PROGRAM_START",
	GET_PT_PROGRAM_SUCCESS: "GET_PT_PROGRAM_SUCCESS",
	GET_PT_PROGRAM_ERROR: "GET_PT_PROGRAM_ERROR",
	GET_PT_PROGRAM_RESET: "GET_PT_PROGRAM_RESET",

	//Create Template name
	CREATE_PT_PROGRAM_START: "CREATE_PT_PROGRAM_START",
	CREATE_PT_PROGRAM_SUCCESS: "CREATE_PT_PROGRAM_SUCCESS",
	CREATE_PT_PROGRAM_ERROR: "CREATE_PT_PROGRAM_ERROR",
	CREATE_PT_PROGRAM_RESET: "CREATE_PT_PROGRAM_RESET",

	//delete Template name
	DELETE_PT_PROGRAM_START: "DELETE_PT_PROGRAM_START",
	DELETE_PT_PROGRAM_SUCCESS: "DELETE_PT_PROGRAM_SUCCESS",
	DELETE_PT_PROGRAM_ERROR: "DELETE_PT_PROGRAM_ERROR",
	DELETE_PT_PROGRAM_RESET: "DELETE_PT_PROGRAM_RESET",

	//update Template name
	UPDATE_PT_PROGRAM_START: "UPDATE_PT_PROGRAM_START",
	UPDATE_PT_PROGRAM_SUCCESS: "UPDATE_PT_PROGRAM_SUCCESS",
	UPDATE_PT_PROGRAM_ERROR: "UPDATE_PT_PROGRAM_ERROR",
	UPDATE_PT_PROGRAM_RESET: "UPDATE_PT_PROGRAM_RESET",

	//single item  name
	SINGLE_PT_PROGRAM_START: "SINGLE_PT_PROGRAM_START",
	SINGLE_PT_PROGRAM_SUCCESS: "SINGLE_PT_PROGRAM_SUCCESS",
	SINGLE_PT_PROGRAM_ERROR: "SINGLE_PT_PROGRAM_ERROR",
	SINGLE_PT_PROGRAM_RESET: "SINGLE_PT_PROGRAM_RESET",
};

export default types;
